import React, { FC } from 'react';
import styled from 'src/theme';

import { StepType } from 'src/store/RoofStoreModule';

import { usePresenter } from './usePresenter';
import { StepButton } from './StepButton';

interface Props {}

export const StepNav: FC<Props> = () => {
  const presenter = usePresenter();

  return (
    <StepsListStyled>
      {presenter.steps.map((step) => (  // test
        <StepItemStyled key={step.id}>
          <StepButton
            icon={step.icon}
            color={step.color}
            text={step.text}
            onClick={() => presenter.changeStep(step.id as StepType)}
            disabled={presenter.currentStep > step.id || presenter.currentStep === step.id - 1}
          />
        </StepItemStyled>
      ))}
    </StepsListStyled>
  );
};

const StepsListStyled = styled.ul`
  display: flex;
  list-style: none;
  margin-bottom: 80px;
  @media screen and ${props => props.theme.media.tablet} {
    margin-bottom: 65px;
  }
  @media screen and ${props => props.theme.media.mobile} {
    margin-bottom: 50px;
  }
`;

const StepItemStyled = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  
  &+li:before {
    content: "";
    width: 20px;
    margin: auto 6px;
    border-color: ${props => props.theme.colors.orange};
    border-style: solid;
    border-width: 2px 0px 0px 0px;
    border-radius: 2px;
  }
  @media screen and ${props => props.theme.media.tablet} {
    &+li:before {
      width: 15px;
    }
  }
  @media screen and ${props => props.theme.media.mobile} {
    &+li:before {
      width: 10px;
    }
  }
`;
